<template>
  <v-layout justify-center>
    <v-flex xs12 md12>
      <v-card dark class="mb-2"> 
        <v-card-text class="title blue lighten-2 pb-0 mb-0">
          <v-select
            :items="lastestRateItems"
            label="ประเภทบุคคล"
            v-model="selectedItem"
            item-value="id"
            item-text="personType.name"
            return-object
            outline
            @change=""
          ></v-select>
        </v-card-text>
      </v-card>

      <v-card dark>
        <v-card-title class="title red lighten-2">
          แบบที่ 1 แยก L และ G
          <v-spacer></v-spacer>
          <div v-if="selectedItem != null">{{ selectedItem.personType.name }}</div>
        </v-card-title>

        <v-card-text>
          <v-container
            fluid
            grid-list-md
          >
            <v-layout row wrap>
              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">L บรรยาย</h5>
                      <div class="white--text">หลักสูตรปกติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="น.ศ. <200"
                      v-model="form.ln1"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                    <v-text-field
                      label="น.ศ. 201-400"
                      v-model="form.ln2"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                    <v-text-field
                      label="น.ศ. 401>"
                      v-model="form.ln3"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                    <v-text-field
                      label="เหมา"
                      v-model="form.ln4"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">L บรรยาย</h5>
                      <div class="white--text">หลักสูตรนานาชาติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="น.ศ. <200"
                      v-model="form.li1"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                    <v-text-field
                      label="น.ศ. 201-400"
                      v-model="form.li2"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                    <v-text-field
                      label="น.ศ. 401>"
                      v-model="form.li3"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                    <v-text-field
                      label="เหมา"
                      v-model="form.li4"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">L บรรยาย</h5>
                      <div class="white--text">คณะสถาปัตย์ฯ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.la"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">G กลุ่ม</h5>
                      <div class="white--text">หลักสูตรปกติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.gn"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">G กลุ่ม</h5>
                      <div class="white--text">หลักสูตรนานาชาติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.gi"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">G กลุ่ม</h5>
                      <div class="white--text">คณะสถาปัตย์ฯ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.ga"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container> 
        </v-card-text>

        <v-card-title class="title red lighten-2">
          แบบที่ 2 L&G
          <v-spacer></v-spacer>
          <div v-if="selectedItem != null">{{ selectedItem.personType.name }}</div>
        </v-card-title>

        <v-card-text>
          <v-container
            fluid
            grid-list-md
          >
            <v-layout row wrap>
              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">L&G</h5>
                      <div class="white--text">หลักสูตรปกติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.cn"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">L&G</h5>
                      <div class="white--text">หลักสูตรนานาชาติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.ci"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">L บรรยาย</h5>
                      <div class="white--text">หลักสูตรปกติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.cln"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">L บรรยาย</h5>
                      <div class="white--text">หลักสูตรนานาชาติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.cli"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">G กลุ่ม</h5>
                      <div class="white--text">หลักสูตรปกติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.cgn"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md2>
                <v-card light>
                  <v-card-title class="blue lighten-2">
                    <div>
                      <h5 class="title mb-0 white--text">G กลุ่ม</h5>
                      <div class="white--text">หลักสูตรนานาชาติ</div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="เหมา"
                      v-model="form.cgi"
                      outline
                      :disabled="disabled"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-2" @click.native="submit" :disabled="disabled">บันทึกอัตราค่าตอบแทนแบบใหม่</v-btn>
        </v-card-actions>
      </v-card>

    </v-flex>
  </v-layout>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: ['lastestRateItems'],
  data () {
    return {
      disabled: true,
      selectedItem: null,
      form: {
        personType: null,
        /*Lecture NORMAL*/
        ln1: 0,
        ln2: 0,
        ln3: 0,
        ln4: 0,

        /*Lecture INTER*/
        li1: 0,
        li2: 0,
        li3: 0,
        li4: 0,

        /*Lecture ARCH*/
        la: 0,

        /*Lecture RATC*/
        lr: 0,

        gn: 0,/*Group NORMAL*/
        gi: 0,/*Group INTER*/
        ga: 0,/*Group ARCH*/
        gr: 0,

        cn: 0,/*Combine NORMAL*/
        ci: 0,/*Combine INTER*/
        ca: 0,/*Group ARCH*/
        cr: 0,/*Group RATC*/

        cln: 0, /*Combine Lecture NORMAL*/
        cli: 0, /*Combine Lecture INTER*/
        cla: 0,/*Group ARCH*/
        clr: 0,/*Group RATC*/

        cgn: 0, /*Combine Group NORMAL*/
        cgi: 0, /*Combine Group INTER*/
        cga: 0,/*Group ARCH*/
        cgr: 0,/*Group RATC*/
      }
    }
  },
  mounted () {
  },
  methods: {
    submit () {
      console.log('save')
      this.$store.dispatch('wageRate/create', this.form)
          .then((response) => {
            console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {

            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      
    }
  },
  watch: {
    selectedItem (val) {
      console.log(val)
      if(val) {
        this.disabled = false
        this.form = {
          personType: val.personType.id,
          /*Lecture NORMAL*/
          ln1: val.ln1,
          ln2: val.ln2,
          ln3: val.ln3,
          ln4: val.ln4,

          /*Lecture INTER*/
          li1: val.li1,
          li2: val.li2,
          li3: val.li3,
          li4: val.li4,

          /*Lecture ARCH*/
          la: val.la,

          /*Lecture RATC*/
          lr: val.lr,

          gn: val.gn,/*Group NORMAL*/
          gi: val.gi,/*Group INTER*/
          ga: val.ga,/*Group ARCH*/
          gr: val.gr,/*Group RATC*/

          cn: val.cn,/*Combine NORMAL*/
          ci: val.ci,/*Combine INTER*/
          ca: val.ca,/*Group ARCH*/
          cr: val.cr,/*Group RATC*/

          cln: val.cln, /*Combine Lecture NORMAL*/
          cli: val.cli, /*Combine Lecture INTER*/
          cla: val.cla,/*Group ARCH*/
          clr: val.clr,/*Group RATC*/

          cgn: val.cgn, /*Combine Group NORMAL*/
          cgi: val.cgi, /*Combine Group INTER*/
          cga: val.cga,/*Group ARCH*/
          cgr: val.cgr,/*Group RATC*/
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/wageRate/settings.vue